import React, { useCallback, useState } from "react";
import { Text, View } from "react-native";
import { CustomTextInput } from "../../components/customTextInput";
import CustomPressable from "../../components/customPressable/customPressable";
import { useTranslation } from "react-i18next";
import { useCssStyle } from "../../customHook/getCssStyle";
import { useSelector } from "react-redux";


export const AdminVerification = ({ handleNext, handleGoHome }) => {


    const getStyles = useCssStyle();
    const { t } = useTranslation();

    const { extraConfigParam } = useSelector((state) => state.deviceConfigSlice);
    const ecpPassword = extraConfigParam?.SETTING_ACTIVITY_PASSWORD || "9998876";

    const [passwordInput, setPasswordInput] = useState("");
    const [error, setError] = useState(false);

    const handleProceed = useCallback(() => {
        setError(false);

        if (passwordInput === ecpPassword) {
            handleNext();
        } else {
            setError(true);
        }
    }, [passwordInput, ecpPassword, handleNext]);

    return (
        <View style={getStyles(['adminPanelModalChildContainer'])}>

            <View style={getStyles(['textContainer'])}>
                <Text style={getStyles(['label'])}>{t('admin_panel.enter_password')}</Text>
                <CustomTextInput
                    keyboardType="numeric"
                    value={passwordInput}
                    onChangeText={(v) => {
                        setPasswordInput(v);
                        setError(false);
                    }}
                />
                {error && <Text style={getStyles(['errorText'])}>*The password is incorrect</Text>}
            </View>


            <View style={getStyles(['adminPanelModalButtonContainer'])} >
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleProceed}>
                    <Text style={getStyles(['primaryBtnTxt'])}>{t('admin_panel.primary_button')}</Text>
                </CustomPressable>

                <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoHome}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>{t('admin_panel.secondary_button')}</Text>
                </CustomPressable>
            </View>
        </View>
    );
}